<template>
  <div class="modal-container">
    <b-container
      :class="{
        'modal-bp': true,
        small: global.modalData.modalType === 'settings',
      }"
    >
      <div id="modal-content" class="modal-content">
        <div class="modal-top">
          <div class="close-icons">
            <div class="close-icon close-r" @click="closeModal()" />
          </div>
          <h4 v-if="global.screenWidth > 650">{{ title }}</h4>
        </div>
        <div class="modal-primary">
          <div v-if="global.modalData.modalType === 'project'">
            <div
              class="text-overlay"
              v-if="
                imagesArray &&
                imagesArray.length > 0 &&
                description &&
                !hideTextOverlay
              "
            >
              <div class="close-icon close-r" @click="() => toggleOverlay()" />
              <div class="overlay-desc">
                <p v-if="!isHtmlDescription">
                  {{
                    languageHelper.translate(description, {
                      locale: global.locale,
                    })
                  }}
                </p>
                <p
                  v-else
                  v-html="
                    languageHelper.translate(description, {
                      locale: global.locale,
                    })
                  "
                ></p>
              </div>
            </div>

            <ImageGallery
              :data="imagesArray"
              v-if="imagesArray && imagesArray.length > 0"
            />
            <p class="standalone-text-box" v-else-if="!isHtmlDescription">
              {{
                languageHelper.translate(description, {
                  locale: global.locale,
                })
              }}
            </p>
            <p
              class="standalone-text-box"
              v-else
              v-html="
                languageHelper.translate(description, {
                  locale: global.locale,
                })
              "
            ></p>
          </div>

          <div
            class="dyn-options"
            v-if="global.modalData.modalType === 'settings'"
          >
            <div class="options">
              <span
                :class="`${global.locale === 'en' ? 'activeColor' : ''}`"
                @click="
                  setLocale('en');
                  analyticsHelper.langChange('en');
                "
              >
                {{
                  languageHelper.translate("common.english", {
                    locale: global.locale,
                  })
                }}</span
              ><span>/</span
              ><span
                :class="`${global.locale === 'fr' ? 'activeColor' : ''}`"
                @click="
                  setLocale('fr');
                  analyticsHelper.langChange('fr');
                "
              >
                {{
                  languageHelper.translate("common.french", {
                    locale: global.locale,
                  })
                }}</span
              >
            </div>
            <div class="options">
              <span
                @click="
                  setAutoDarkMode(true);
                  analyticsHelper.darkModeChange('auto');
                "
                :class="`${global.autoDarkMode ? 'activeColor' : ''}`"
              >
                Auto</span
              >
              <span>/</span>
              <span
                @click="
                  setAutoDarkMode(false);
                  setDarkMode(true);
                  analyticsHelper.darkModeChange('dark');
                "
                :class="`${
                  global.darkMode && !global.autoDarkMode ? 'activeColor' : ''
                }`"
              >
                {{
                  languageHelper.translate("common.dark", {
                    locale: global.locale,
                  })
                }}
              </span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" v-bind:svg-inline="''" :class="`dark-icon ${
                  global.darkMode && !global.autoDarkMode ? 'activeFillSvg' : ''
                }`" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M63.437 38.46a1 1 0 00-1.227.292c-1.28 1.665-2.945 3.2-4.95 4.562-11.618 7.881-27.545 4.925-35.497-6.595-7.816-11.32-4.99-26.974 6.296-34.894a1 1 0 00-.722-1.808c-4.648.696-9.207 2.49-13.188 5.19-7.178 4.869-12.007 12.22-13.596 20.7-1.582 8.442.24 16.994 5.13 24.08 6.288 9.106 16.487 14.006 26.856 14.006a32.49 32.49 0 0018.294-5.616c6.58-4.462 11.246-11.13 13.14-18.776a1 1 0 00-.536-1.14zM49.71 56.723c-13.871 9.41-32.885 5.883-42.38-7.872-4.586-6.642-6.295-14.66-4.812-22.574 1.49-7.952 6.02-14.847 12.754-19.415a30.468 30.468 0 018.365-3.973c-9.392 9.07-11.142 23.926-3.52 34.967 8.573 12.42 25.741 15.61 38.266 7.114.826-.561 1.6-1.15 2.318-1.765-2.22 5.443-6.024 10.15-10.991 13.518z"/></svg>
              <span>/</span>
              <span
                @click="
                  setAutoDarkMode(false);
                  setDarkMode(false);
                  analyticsHelper.darkModeChange('light');
                "
                :class="`${
                  !global.darkMode && !global.autoDarkMode ? 'activeColor' : ''
                }`"
              >
                {{
                  languageHelper.translate("common.light", {
                    locale: global.locale,
                  })
                }}
              </span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" v-bind:svg-inline="''" :class="`light-icon ${
                  !global.darkMode && !global.autoDarkMode
                    ? 'activeFillSvg'
                    : ''
                }`" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#231F20" d="M31.324 25.224c0-3.86-3.141-7-7-7s-7 3.14-7 7c0 3.859 3.141 7 7 7s7-3.141 7-7zm-7 5c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5zM23.324 34.09v6.134a1 1 0 102 0V34.09a1 1 0 10-2 0zM23.324 10.224v6.134a1 1 0 102 0v-6.134a1 1 0 10-2 0zM34.224 36.537a.997.997 0 001.414 0 .999.999 0 000-1.414L31.3 30.786a.999.999 0 10-1.414 1.414l4.338 4.337zM13.011 13.91a.999.999 0 000 1.414l4.338 4.337a.997.997 0 001.414 0 .999.999 0 000-1.414l-4.338-4.337a1 1 0 00-1.414 0zM39.324 24.224H33.19a1 1 0 100 2h6.134a1 1 0 100-2zM8.324 25.224a1 1 0 001 1h6.134a1 1 0 100-2H9.324a1 1 0 00-1 1zM34.224 13.91l-4.338 4.338a.999.999 0 101.414 1.414l4.338-4.338a.999.999 0 10-1.414-1.414zM13.718 36.83a.997.997 0 00.707-.293l4.338-4.337a.999.999 0 10-1.414-1.414l-4.338 4.337a.999.999 0 00.707 1.707z"/></svg>
            </div>
          </div>
        </div>
        <div
          class="bottom-container"
          v-if="imagesArray && imagesArray.length > 0 && description"
        >
          <div class="text-info">
            <img
              :src="
                require(global.darkMode
                  ? '@/assets/images/icons/info-dark.png'
                  : '@/assets/images/icons/info-light.png')
              "
              @click="() => toggleOverlay()"
            />
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>


<script>
import ImageGallery from "@/components/global/ImageGallery";
import { mapActions, mapState } from "vuex";
import { languageHelper, analyticsHelper } from "@/helpers";

export default {
  name: "modal",
  components: {
    ImageGallery,
  },
  data() {
    return {
      imagesArray: [],
      title: "",
      description: null,
      hideTextOverlay: true,
      disableClickOut: false,
      isHtmlDescription: false,
      languageHelper,
      analyticsHelper,
    };
  },
  computed: {
    ...mapState(["global"]),
  },
  mounted() {
    const modalData = this.global.modalData.data;
    const modalType = this.global.modalData.modalType;
    if (modalType === "project") {
      this.title = modalData.title;
      this.imagesArray = modalData.gallery;
      this.description = modalData.description;
      this.isHtmlDescription = modalData.isHtmlDescription;
      this.setListeners();
    }
    if (!this.global.modalData) {
      this.removeListeners();
    }
  },
  beforeDestroy() {
    this.removeListeners();
  },
  methods: {
    toggleOverlay() {
      if (this.hideTextOverlay) {
        this.disableClickOut = true;
      } else {
        setTimeout(() => {
          this.disableClickOut = false;
        }, 100);
      }
      this.hideTextOverlay = !this.hideTextOverlay;
    },
    closeModal() {
      this.setModalData(null);
      this.removeListeners();
    },
    setListeners() {
      document.addEventListener("keydown", this.handleEscape);
      setTimeout(
        () => document.addEventListener("click", this.handleClickOut),
        600
      );
    },
    removeListeners() {
      document.documentElement.style.overflow = "auto";
      document.removeEventListener("keydown", this.handleEscape);
      document.removeEventListener("click", this.handleClickOut);
    },
    handleClickOut(evt) {
      if (this.disableClickOut) return;

      let flyoutElement = document.getElementById("modal-content");
      let targetElement = evt.target;
      do {
        if (targetElement == flyoutElement) {
          return;
        }
        targetElement = targetElement.parentNode;
      } while (targetElement);
      this.closeModal();
    },
    handleEscape(e) {
      if (e && e.keyCode === 27) {
        this.closeModal();
      }
    },
    ...mapActions([
      "setModalData",
      "setLocale",
      "setDarkMode",
      "setAutoDarkMode",
    ]),
  },
};
</script>

<style lang="scss" scoped>
.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.89);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .modal-bp {
    @media (max-width: $lg) {
      max-width: 100vw;
      margin: 0;
      width: 100%;
    }
    @media (max-width: $md) {
      padding: 0;
    }
  }
  .small {
    width: 500px;
  }
  .standalone-text-box {
    overflow-y: scroll;
    padding: 30px;
    width: 900px;
  }
  .overlay-desc {
    max-width: 100%;
    padding-top: 30px;
  }
  .text-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 12;
    background-color: $lt-bg-color;
    border-radius: 11px;
    padding: 22px;
    max-width: 95%;
    @media (max-width: $md) {
      width: 100%;
    }
    p {
      max-width: 100%;
    }
  }
  .bottom-container {
    height: 55px;
    background: $lt-modal-window-top;
    width: 100%;
    padding-right: 18px;
    padding-bottom: 14px;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-end;
  }
  .text-info {
    height: 32px;
    width: 32px;

    display: flex;
    align-items: center;
    justify-content: center;
    img {
      max-height: 26px;
      max-width: 26px;
      filter: $lt-secondary-color;
    }
  }
  p {
    padding: 30px;
    font-family: $font-primary;
    font-size: 18px;
    color: #000;
    max-width: 100%;
    word-break: break-word;
    @media (max-width: $md) {
      padding: 4px;
    }
  }
  .modal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background: #ffffff;
    box-shadow: 0 6px 20px 10px rgba(0, 0, 0, 0.1);
    border-radius: 22px;
    overflow: hidden;
    min-height: 25vh;
    max-height: 90vh;
  }
  .modal-top {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background: $lt-modal-window-top;
    width: 100%;
    height: 54px;
    min-height: 54px;
    position: relative;
    padding: 0 100px;
    overflow: hidden;

    h4 {
      font-family: $font-header;
      font-size: 24px;
      color: $lt-dark-gray;
      text-transform: capitalize;
    }
    // transform: translateY(-100%);
  }
  .close-icons {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    position: absolute;
    top: 50%;
    left: 48px;
    transform: translate(-50%, -50%);
  }
  .close-icon {
    cursor: pointer;
    height: 19px;
    width: 19px;
    border-radius: 50%;
    margin-right: 9px;
  }

  .close-r {
    background: $red-close;
  }
  .close-y {
    background: $yellow-close;
  }
  .close-g {
    background: $green-close;
  }
  #modalCarousel {
    width: 100%;
    height: max-content !important;
    max-height: calc(100vh - 44px);
  }
}
.modal-primary {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  div{
    max-width: 100%;
    width: 100%;
  }
}
.navArrow {
  height: 68px;
  width: 68px;
  border-radius: 50%;
  transition: all 0.2s ease-in-out;
  transform: translateX(50%);
  @media (max-width: $md) {
    transform: none;
  }

  img {
    height: 20px;
    width: 20px;
  }
}
#prevArrow {
  transform: scaleX(-1) translateX(50%);
  @media (max-width: $md) {
    transform: scaleX(-1);
  }
}
.navArrow:focus {
  outline: none;
}

.dyn-options {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
@media (max-height: $md) {
  .dyn-options {
    flex-direction: row !important;
    flex-wrap: wrap;
    justify-content: flex-end;
  }
}
.options {
  padding: 25px;
  margin-bottom: 12px;
  margin-right: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  cursor: pointer;
  max-width: 100%;

  @media (max-height: $md) {
    padding: 7px;
  }
  span,
  img,
  svg {
    margin-right: 10px;
    font-size: 18px;
    font-family: $font-primary;
    &:last-child {
      margin-right: 0;
    }
  }

  svg,
  img {
    height: 30px;
    width: auto;
  }
  .dark-icon {
    height: 15px;
  }
  .light-icon {
    height: 25px;
  }
}
.activeColor {
  color: $lt-secondary-color;
}
</style>
<style lang="scss">
.modal-container {
  *:focus {
    outline: 0;
    outline: none;
  }
  .hooper-slide {
    // height: max-content !important;
    width: 100% !important;
    display: flex;
    align-items: center;
    justify-content: center;
    height: max-content;
  }
  .hooper-track {
    height: max-content;
    max-height: 100vh;
  }
  .hooper-list {
    height: max-content;
  }
  .hooper {
    height: max-content;
  }
  .hooper-track {
    // height: 800px !important;
    // max-height: 85vh!important;
    display: flex;
    align-items: center;
  }
}
</style>



<style lang="scss" >
.dark {
  .modal-container {
    background: rgba(0, 0, 0, 0.89) !important;
    .options {
      transition: background-color 0.25s ease-in;
    }
    .text-overlay {
      background-color: $dt-bg-color;
    }
    .bottom-container {
      background: $dt-modal-window-top;
    }
    .modal-content {
      background: $dt-bg-color;
      box-shadow: 0 6px 20px 10px rgba(0, 0, 0, 0.1);
    }
    .options {
      span {
        color: rgb(117, 117, 117);
      }
    }
    p {
      color: $dt-font-color;
    }

    .modal-top {
      background: $dt-modal-window-top;

      h4 {
        color: $dt-font-color;
      }
    }
  }
  svg {
    path {
      fill: $dt-secondary-color !important;
    }
  }
}
</style>
